import React, { useState, useEffect } from "react";
import { Box, Select, Typography, MenuItem, FormControl, InputLabel } from "@mui/material";
import { i18n } from '../../../../translate/i18n';
import { SelectChangeEvent } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { ISite } from "../../../../models/isite";
import monthToText from "../../../../utils/monthToText";
import * as actions from '../../../../store/actions';
import { RootState } from "../../../../store/types";
import UsersFilters from "./UsersFilters";

const PlannerHeader: React.FC = () => {
  const dispatch = useDispatch();
  
  const sites = useSelector((state: any) => state.sites.allSites);
  const selectedSiteId = useSelector((state:RootState) => state.scheduledServices.selectedSiteId);
  const [value, setValue] = useState<string>("");

  const today = new Date();
  const month = monthToText(today.getMonth());
  const year = today.getFullYear();

  useEffect(() => {
    const siteId = sites?.rows[0]?._id || '';
    if (selectedSiteId === '') {
      dispatch(actions.scheduledServicesSelectSite(siteId));
      setValue(siteId);
    } else {
      setValue(selectedSiteId);
    }
  }, [sites]);

  const handleChange = (event: SelectChangeEvent) => {
    dispatch(actions.scheduledServicesSelectSite(event.target.value));
    setValue(event.target.value);
  };
  return (
    <Box>
      <Typography sx={styles.title} variant='h5'>{i18n.t('scheduledServicesPlannerHeader.scheduledServices') as string}</Typography>
      <Box sx={styles.monthContainer}>
        <Typography variant="h5" sx={styles.month}>{`${month} ${year}`}</Typography>
        <FormControl sx={styles.siteSelect} size="small">
          <InputLabel id="site-select-scheduled-services-label">Site</InputLabel>
          <Select
            labelId="site-select-scheduled-services-label"
            id="site-select-scheduled-services"
            value={value}
            label="Site"
            onChange={handleChange}
            sx={{ maxWidth: '25rem'}}
          >
            {sites.rows.map((site: ISite) => <MenuItem key={site._id} value={site._id}>{site.name}</MenuItem>)}
          </Select>
        </FormControl>
      </Box>
      <UsersFilters />
    </Box>
  )
};

export default PlannerHeader;

const styles = {
  title: {
    marginTop: '10px',
    marginBottom: '50px',
  },
  monthContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '50px',
  },
  month: {
    marginRight: '100px',
  },
  siteSelect: {
    width: '30%',
  },
};
